import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ImageService } from '../../../../../../../services/images/image.service';
import { environment } from '../../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../../core/animations';
import { TranslationService } from '../../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../../services/sweet-alert/sweet-alert.service';
import { PersonGenderService } from '../../../../../../../services/person-genders/person-gender.service';
import { StudentService } from '../../../../../../../services/students/student.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DivisionService } from '../../../../../../../services/divisions/division.service';
import { AuthenticationService } from '../../../../../../../services/authentication/authentication.service';

import { Lightbox } from 'ngx-lightbox';
import { MY_FORMATS } from '../../../../../../../const/date-format';

import { Observable } from 'rxjs/Observable';
import { PaymentComponent } from '../../payment/payment.component';
import { Payment } from '../../../../../../../models/payment/payment';
import { PaymentConceptService } from '../../../../../../../services/payment-concept/payment-concept.service';
import { AddEditPaymentDto } from '../../../../../../../models/students/dto/AddEditPaymentDto';

@Component({
    selector: 'fuse-add-payment',
    templateUrl: './add-payment.component.html',
    styleUrls: ['./add-payment.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class AddorEditPaymentComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    studentFormGroup;
    tutorFormGroup;

    courseFormControl;
    studentDocNumberFormControl;
    studentLastNameFormControl;
    studentFirstNameFormControl;

    markerLngX: number = null;
    markerLatY: number = null;
    confirmDialogRef: any;
    public baseUri;

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerTutorBirthdate;
    maskedInputControllerStudentBirthdate;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AddorEditPaymentComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private studentService: StudentService,
        private fb: FormBuilder,
        private divisionService: DivisionService,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        public paymentConceptService: PaymentConceptService
    ) {
        console.log('AddEditPayment*** > data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        const observables = [];
        observables.push(this.studentService.getById(this.data.student.Id, this.authenticationService.getAuthData().SchoolYear.Id));
        observables.push(this.paymentConceptService.getAll());
        Observable.combineLatest(
            observables
        ).subscribe((result) => {
            console.log(result[0]);
            this.data.student = result[0];
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.studentFormGroup.get('courseFormControl').disable();
        this.studentFormGroup.get('studentDocNumberFormControl').disable();
        this.studentFormGroup.get('studentLastNameFormControl').disable();
        this.studentFormGroup.get('studentFirstNameFormControl').disable();
    }

    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        
    }

    initializeFormControlValidators() {
        this.studentFormGroup = this.fb.group({
            courseFormControl: ['', [Validators.required]],
            studentDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            studentLastNameFormControl: ['', [Validators.required]],
            studentFirstNameFormControl: ['', [Validators.required]],
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    setMarker($event: any) {
        // console.log('FuseAddStoreComponent > setMarker > $event', $event);
        this.markerLngX = $event.coords.lng;
        this.markerLatY = $event.coords.lat;
    }

    save() {
        if (this.data.mode === 'new') {
            console.log('nuevo');
            this.addStudent();
        } else {
            console.log('editar');
            this.editStudent();
        }
    }

    addStudent() {
        this.blockUI.start(this.translationService.savingChanges);
        const addStudentDto = new AddEditPaymentDto();

        addStudentDto.FirstName = this.data.student.FirstName;
        addStudentDto.LastName = this.data.student.LastName;
        addStudentDto.DocumentNumber = this.data.student.DocumentNumber;
        addStudentDto.DivisionId = this.data.student.DivisionId;
        addStudentDto.SchoolYearId = this.authenticationService.getAuthData().SchoolYear.Id;
        addStudentDto.Payments = this.data.student.Payments;

        this.studentService.addOrEditPayment(addStudentDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.student.Id = response.Id;
                this.studentService.students.push(this.data.student);
                this.studentService.studentObject[this.data.student.Id] = this.data.student;
                this.dialogRef.close(this.data.student);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.payment, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }

    editStudent() {
        this.blockUI.start(this.translationService.savingChanges);

        const addStudentDto = new AddEditPaymentDto();

        addStudentDto.Id = this.data.student.Id;
        addStudentDto.FirstName = this.data.student.FirstName;
        addStudentDto.LastName = this.data.student.LastName;
        addStudentDto.DocumentNumber = this.data.student.DocumentNumber;
        addStudentDto.DivisionId = this.data.student.DivisionId;

        addStudentDto.Payments = this.data.student.Payments;

        this.studentService.addOrEditPayment(addStudentDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
               /* const index = this.studentService.students.findIndex(st => st.Id === this.data.student.Id);
                console.log('valor index', index);
                console.log(this.studentService.students[index]);*/       
                /*this.studentService.students[index] = this.data.student;
                this.studentService.studentObject[this.data.student.Id] = this.data.student;*/
                this.dialogRef.close(this.data.student);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.payment, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    addPayment() {
        const payment = new Payment();

        const config: MatDialogConfig = {
            // height: '75%',
            width: '400px',
            height: '400px',
            disableClose: true,
            data: {
                mode: 'new',
                payment: JSON.parse(JSON.stringify(payment))
            }
        };

        this.confirmDialogRef = this.dialog.open(PaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result) {
                const found = this.data.student.Payments.find(p => p.Id === result.Id);
                if (found) {
                    found.Id = result.Id;
                    found.Date = result.Date;
                    found.Amount = result.Amount;
                    found.PaymentConceptId = result.PaymentConceptId;
                    found.Observation = result.Observation;
                    found.ReceiptNumber = result.ReceiptNumber;
                } else {
                    const pay = new Payment();
                    pay.Id = result.Id;
                    pay.Date = result.Date;
                    pay.Amount = result.Amount;
                    pay.PaymentConceptId = result.PaymentConceptId;
                    pay.Observation = result.Observation;
                    pay.ReceiptNumber = result.ReceiptNumber;
                    this.data.student.Payments.push(pay);
                }
            }
        });
    }

    editPayment(payment) {
        const config: MatDialogConfig = {
            // height: '75%',
            width: '400px',
            height: '350px',
            disableClose: true,
            data: {
                mode: 'edit',
                payment: JSON.parse(JSON.stringify(payment))
            }
        };

        this.confirmDialogRef = this.dialog.open(PaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result) {
                const found = this.data.student.Payments.find(p => p.Id === result.Id);
                if (found) {
                    found.Id = result.Id;
                    found.Date = result.Date;
                    found.Amount = result.Amount;
                    found.PaymentConceptId = result.PaymentConceptId;
                    found.Observation = result.Observation;
                    found.ReceiptNumber = result.ReceiptNumber;
                } else {
                    const pay = new Payment();
                    pay.Id = result.Id;
                    pay.Date = result.Date;
                    pay.Amount = result.Amount;
                    pay.PaymentConceptId = result.PaymentConceptId;
                    pay.Observation = result.Observation;
                    pay.ReceiptNumber = result.ReceiptNumber;
                    this.data.student.Payments.push(pay);
                }
            }
        });
    }

    deletePayment(payment) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', '', (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                const found = this.data.student.Payments.find(p => p.Id === payment.Id);
                if (found) {
                    found.IsActive = false;
                }
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/payment/add-payment/add-payment.component.ts